import { MoreOutlined } from "@ant-design/icons";
import './TierData.css'
export const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Condition Value",
    dataIndex: "value",
    key: "value",
  },

  {
    title: "Action",
    dataIndex: "action",
    className: "text-center",
    width: "100px",
    render: () => {
      return (
        <div
          className="d-flex justify-content-center cursor-pointer"
        >
          <MoreOutlined className="more-action" />
        </div>
      );
    },
  },
];
export const tierData = [
  { name: 'Bronze', value: 500 },
  { name: 'Silver', value: 300 },
];
